import React from 'react';
import styled from 'styled-components';
import Lottie from 'react-lottie';

import { LottieAnimationRecolor, LottieAnimationProperty } from '../lottie/LottieAnimationRecolor';
import CircleArrowAnimationData from '../lottie/data/CircleArrowAnimationData.json';

import CircleArrowContainer from './CircleArrowStyles';

class CircleArrow extends React.Component {
    constructor(props) {
        super(props);

        var animationDataChanges = [];

        if (props.arrowColor) {
            animationDataChanges.push({
                layerName: "arrow",
                property: LottieAnimationProperty.fill,
                pathName: "Path 1", // arrow
                colorString: props.arrowColor
            });
        }

        if (props.arrowColor) {
            animationDataChanges.push({
                layerName: "circle",
                property: LottieAnimationProperty.stroke,
                pathName: "Ellipse Path 1", // circle
                colorString: props.circleColor
            });
        }

        if (props.circleAnimationColor) {
            animationDataChanges.push({
                layerName: "circle 2",
                property: LottieAnimationProperty.stroke,
                pathName: "Ellipse Path 1", // animated circle
                colorString: props.circleAnimationColor
            });
        }

        if (props.backgroundColor) {
            animationDataChanges.push({
                layerName: "white circle", // background circle
                property: LottieAnimationProperty.fill,
                pathName: "Ellipse Path 1",
                colorString: props.backgroundColor
            });
        }

        var animationOptions = {
            loop: false,
            autoplay: false,
            rendererSettings: {
                preserveAspectRatio: 'xMidYMid slice'
            },
            animationData: new LottieAnimationRecolor(CircleArrowAnimationData, animationDataChanges)
    };

    if(!props.circleDiameter) {
        throw "circleDiameter not defined!";
    }

        this.state = {
    animationOptions: animationOptions,
    circleDiameter: props.circleDiameter,
    playAnimation: false,
    hoverContainer: null
};
    }

playAnimation() {
    this.setState({ playAnimation: true });
}

stopAnimation() {
    this.setState({ playAnimation: false });
}

render() {
    return (<CircleArrowContainer
        className="circle-arrow"
        circleDiameter={this.state.circleDiameter}>
        <Lottie options={this.state.animationOptions}
            isStopped={!this.state.playAnimation}
        />
    </CircleArrowContainer>
    );
}
}

export default CircleArrow;


// WEBPACK FOOTER //
// ./src/images/animations/CircleArrow/CircleArrow.js